import { gql } from "apollo-boost"

export const getInvoices = gql`
  query Invoices($id: ID!) {
    Submission:Invoices(id: $id) {
      region
      status
      endDate
      budgeted
      startDate
      evidenced
      approved
      difference
      concepts {
        id
        type
        name
        index
        region
        budgeted
        unitCost
        totalUnits
        measurementUnit
        monthlyDistribution
        monthlyDistributionHours
        investmentDistribution {
          id
          name
          type
          percentage
        }
      }
      invoices {
        id
        uuid
        issuer
        rfc
        issuedAt
        receptor
        monthAt
        reviewed
        concept
        category
        paymentMethod
        invoicePaid
        paymentAt
        ficosecPayment
        investmentOnePayment
        investmentTwoPayment
        implementerPayment
        amount
        percentage
        typeRH
        documents {
          id
          type
          name
          url
          invoiceType
        }
      }
      documents {
        id
        type
        name
        url
        month
      }
    }
  }
`
